import {
  Box,
  VStack,
  Text,
  SkeletonText,
  Avatar,
} from "@chakra-ui/react";
import React from "react";
import ReactCountryFlag from "react-country-flag";
import { useTranslations } from "next-intl";
import SectionContainer from "../../components/layout/SectionContainer";
import type { ICoachesPageSectionProps } from "./interfaces";
import type { CoachAvailableLanguages } from "lib/utils/constants";
import { COACH_AVAILABLE_LANGUAGES } from "lib/utils/constants";
import type { CoachTranslations} from "src/contexts/LocalesContext";
import { useLocales } from "src/contexts/LocalesContext";
import { FaUser } from "react-icons/fa";


const CoachesSection = ({ data, loading }: ICoachesPageSectionProps) => {
  const coach = data?.coach_by_pk;
  const { getTranslations } = useLocales();
  const t = useTranslations("pages.coach");
  const translatedContent = getTranslations<CoachTranslations>(coach?.coach_translations as CoachTranslations[]);

  return (
    <Box id="planos-de-treino" mt={-36} pos="relative" zIndex={10}>
      <SectionContainer h="full" pt={0} pb={8}>
        <Box
          display="flex"
          flexDirection={["column", "column", "row", "row"]}
          justifyContent="center"
          alignItems={["center", "center", "flex-start", "flex-start"]}
          p={10}
          gap={[4, 4, 12, 12]}
          w="full"
          bg="lightGray"
        >
          <Avatar
            height="160px"
            width="160px"
            bg="white"
            src={coach?.profile_picture}
            icon={<FaUser color="lightGray" fontSize="6rem" />}
            mb="6"
          />
          <VStack
            flex={1}
            alignItems="flex-start"
            justifyContent="center"
            alignSelf="stretch"
            gap={6}
          >
            <SkeletonText isLoaded={!loading}>
              <Text dangerouslySetInnerHTML={{ __html: translatedContent?.bio || "" }} />
            </SkeletonText>

            <Box>
              {t("speakCoach")}
              {coach?.spoken_languages?.map(lang => (
                <Text as="li" key={lang}>
                  <ReactCountryFlag
                    countryCode={COACH_AVAILABLE_LANGUAGES[lang as CoachAvailableLanguages].flagCode}
                  />
                  {" "}
                  {COACH_AVAILABLE_LANGUAGES[lang as CoachAvailableLanguages].label}
                </Text>
              ))}
            </Box>
          </VStack>
        </Box>
      </SectionContainer>
    </Box>
  );
};

export default CoachesSection;
